import React from "react";
import Byj from "../assets/images/rmhj.png";


const ByjDetails = () => {
  return (
    <section className="team-details">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-lg-5">
            <div className="team-details__content">
              <h2 className="team-details__title">溶媒货架</h2>
              <h3 className="team-details__subtitle" style={{ fontWeight: "bold" }}>产品特点</h3>
              <strong style={{ color: "black" }}>立体式存储</strong>:
              与HIS无缝链接，能实时与HIS系统交换数据。
              自动提示当前所用溶媒的品名、规格、数量和所在位置，防止出现溶媒贴签差错。
              具备溶媒添加自动提示功能，防止出现溶媒贴添加差错。
              单台设备具备储存≥20个品规的溶媒。<br />
              <br/>
              <br/>
              <strong style={{ color: "black" }}>设计理念</strong>
              结构简单、耐用、可靠。设计原理上就将故障发生的可能性降到最低。
              部件选用上遵循“大马拉小车”的原则，保证部件寿命的足够设计冗余，以满足医院这一特殊用户群体的无故障要求。<br />
            </div>
          </div>
          <div className="col-lg-6">
            <h2 className="team-details__title">运用场景</h2>
            <p className="team-details__text">
            药师可通过智能溶媒货架系统来管理溶媒数量及配合贴签机提示品规及数量。</p><br />
            <div className="team-one__single">
              <div className="course-one__image">
                <img src={Byj} alt="" />
              </div>

              <div className="team-one__content">
                <h2 className="team-one__name">
                  <a href="/byj-details">智能溶媒货架</a>
                </h2>
                <p className="team-one__designation">苏州卫捷</p>
              </div>
              <div className="team-one__social">
                <a href="#none">
                  <i className="fab "></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ByjDetails;
